import { CepSteps, CepGroups } from 'basics/enums/cep.enums';

export const goalStepFields = {
  targetEngagementGoal: `${CepSteps.goalStep}.${CepGroups.goal}.targetEngagementGoal`,
  npsGoal: `${CepSteps.goalStep}.${CepGroups.goal}.npsGoal`,
  reachGoal: `${CepSteps.goalStep}.${CepGroups.goal}.reachGoal`,
};

